export const LOADING_ALLOW = 'LOADING_ALLOW'
export const LOADING_START = 'LOADING_START'
export const LOADING_STOP = 'LOADING_STOP'
